import Language from './Language';

const language = new Language();

export default language;

export const LanguageVue = {
  install(Vue) {
    Vue.prototype.$lang = language;
  },
  language,
};
